import React, {Component} from 'react';
import './Skills.css';
import javaIcon from './assets/skills/java.svg';
import springBootIcon from './assets/skills/Spring_Boot.svg';
import restApiIcon from './assets/skills/rest-api.svg';
import microserviceIcon from './assets/skills/microservice.svg';
import sqlIcon from './assets/skills/sql.svg';
import postgresqlIcon from './assets/skills/postgresql.svg';
import awsIcon from './assets/skills/aws.svg';
import dockerIcon from './assets/skills/docker.svg';
import jenkinsIcon from './assets/skills/jenkins.svg';
import gitIcon from './assets/skills/git.svg';
import kafkaIcon from './assets/skills/kafka.svg';
import rabbitMqIcon from './assets/skills/rabbitmq.svg';
import outboxIcon from './assets/skills/outbox.svg';
import asyncIcon from './assets/skills/async.svg';
import redisIcon from './assets/skills/redis.svg';
import reactIcon from './assets/skills/react.svg';
import javascriptIcon from './assets/skills/javascript.svg';
import dashboardIcon from './assets/skills/dashboard.svg';
import aiIcon from './assets/skills/ai.svg';

const skillGroups = [
    {
        title: 'Backend Engineering',
        focus: 'Core strength',
        skills: [
            { name: 'Java', icon: javaIcon },
            { name: 'Spring Boot', icon: springBootIcon },
            { name: "REST API's", icon: restApiIcon },
            { name: 'Microservices', icon: microserviceIcon },
            { name: 'SQL', icon: sqlIcon },
            { name: 'PostgreSQL', icon: postgresqlIcon }
        ]
    },
    {
        title: 'Cloud & DevOps',
        focus: 'Production delivery',
        skills: [
            { name: 'AWS Services', icon: awsIcon },
            { name: 'Docker', icon: dockerIcon },
            { name: 'Jenkins', icon: jenkinsIcon },
            { name: 'Git/Bitbucket', icon: gitIcon }
        ]
    },
    {
        title: 'Event-Driven Systems',
        focus: 'Real-time workflows',
        skills: [
            { name: 'Kafka', icon: kafkaIcon },
            { name: 'PulsarQ', icon: rabbitMqIcon },
            { name: 'Transactional Outbox', icon: outboxIcon },
            { name: 'Async Processing', icon: asyncIcon },
            { name: 'Redis', icon: redisIcon }
        ]
    },
    {
        title: 'Frontend & AI',
        focus: 'Product visibility',
        skills: [
            { name: 'ReactJS', icon: reactIcon },
            { name: 'JavaScript', icon: javascriptIcon },
            { name: 'Dashboards', icon: dashboardIcon },
            { name: 'AI-Enabled Systems', icon: aiIcon }
        ]
    }
];

const SkillIcon = ({ icon }) => (
    <span className="skillIcon" aria-hidden="true">
        <img src={icon} alt="" />
    </span>
);

class Skills extends Component {
    state = {  }
    render() {
        return (
            <div>
                <div className="divSkillsStyle">
                    <div className="divAboutMeHeader" >
                    <h1 >Technical Focus</h1>
                    <hr className="solid-Skills"></hr>
                    </div>
                    <div className="skillsIntro">
                        Backend-first engineering across Java services, cloud infrastructure, event-driven workflows, and practical AI integration.
                    </div>
                    <div className="divSkillsMatrix">
                        {skillGroups.map((group) => (
                            <div className="skillGroupCard" key={group.title}>
                                <div className="skillGroupHeader">
                                    <span>{group.focus}</span>
                                    <h3>{group.title}</h3>
                                </div>
                                <div className="skillIconGrid">
                                    {group.skills.map((skill) => (
                                        <div className="skillIconTile" key={skill.name}>
                                            <SkillIcon icon={skill.icon} />
                                            <span>{skill.name}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                </div >
            </div>
        );
    }
}
 
export default Skills;
